import React from 'react';
import { NotepadText, X } from 'lucide-react';
import { OrderDetailsNotesPanel } from './OrderDetailsNotesPanel';

export function OrderDetailsNotesColPanel({
  notes,
  loadingNotes,
  savingNote,
  notesError,
  saveError,
  onSubmit,
  onClose,
  startComposeOpen = false,
}) {
  return (
    <aside
      id="order-details-v2-notes-panel"
      className="order-details-v2-col order-details-v2-col--notes"
      aria-label="Anotações"
    >
      <div className="order-details-v2-notes-col-panel">
        <div className="order-details-v2-notes-col-head order-details-v2-block-head">
          <h3 className="order-details-v2-block-title">
            <NotepadText size={20} strokeWidth={2} aria-hidden />
            Anotações
          </h3>
          <button
            type="button"
            className="order-details-v2-notes-col-close"
            title="Fechar anotações"
            aria-label="Fechar anotações"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose?.();
            }}
          >
            <X size={14} strokeWidth={2.25} aria-hidden />
          </button>
        </div>
        <div className="order-details-v2-notes-col-body">
          <OrderDetailsNotesPanel
            notes={notes}
            loadingNotes={loadingNotes}
            savingNote={savingNote}
            notesError={notesError}
            saveError={saveError}
            onSubmit={onSubmit}
            floatingCompose
            startComposeOpen={startComposeOpen}
          />
        </div>
      </div>
    </aside>
  );
}
